import React from 'react';

import "../../_common/common.css"
import "./about.css"

const About = () => {

    return (
        <div className="home-section container-about">
            <div className="about-text">
                <span className="about-text-main"><span className="about-text-hi">Hey</span><br/> I'm <span className="about-name">Kristina</span></span>
                <br/><span className="about-text-subtitle">I'm a React Native Intern at Shopify</span>
                <br/><br/> Currently, I'm working as a client developer on <a target="_blank" href="https://shop.app">Shop</a>. I work on developing reusable and effective React Native components and using GraphQL to communicate between the Shop client and the server.
                <br/><br/> I'm familair with Rails, React, React Native, GraphQL, Ruby, SQL, JavaScript, and Typescript by being in the Dev Degree program and completing a full-stack development training path.
                <br/><br/> Previously, I interned at Activeloop in a Developer Relations role and Botmock in a Software Developer role.
                <br/><br/>Below are some of the things I've worked on :)
            </div>
            
        </div>
    );
}

export default About;



// WEBPACK FOOTER //
// ./src/components/home/about/About.js